export const minecraft1216 = {
  version: '1.21.6',
  title: 'Chase the Skies',
  image: 'https://www.minecraft.net/content/dam/minecraftnet/games/minecraft/key-art/MCV_ChaseTheSkies_launch_Header_1170x500.jpg',
  releases: [
    {
      id: "60aT4Noc",
      version: "1.0.4",
      date: "Jul 24, 2025",
      changelog: "Versión estable para Minecraft 1.21.6 con todos los mods actualizados",
      downloadUrl: "https://modrinth.com/modpack/simonuwu-fabric-project/version/1.0.4-1.21.6",
      curseforgeUrl: "https://www.curseforge.com/minecraft/modpacks/simonuwu-fabric-project",
      isBeta: false
    },
    {
      id: "110hW0Vuj",
      version: "beta-0.5-1.0.4",
      date: "Jul 8, 2025",
      changelog: "Nueva versión beta 0.5 con mejoras adicionales y nuevas características para Minecraft 1.21.6",
      downloadUrl: "https://modrinth.com/modpack/simonuwu-fabric-project/version/0.5-1.0.4-1.21.6",
      curseforgeUrl: "https://www.curseforge.com/minecraft/modpacks/simonuwu-fabric-project",
      isBeta: true
    },
    {
      id: "100gV9Rui",
      version: "beta-0.4-1.0.4",
      date: "Jul 5, 2025",
      changelog: "Nueva versión beta 0.4 con mejoras adicionales y nuevas características para Minecraft 1.21.6",
      downloadUrl: "https://modrinth.com/modpack/simonuwu-fabric-project/version/0.4-1.0.4-1.21.6",
      curseforgeUrl: "https://www.curseforge.com/minecraft/modpacks/simonuwu-fabric-project",
      isBeta: true
    },
    {
      id: "90fV8Rth",
      version: "beta-0.3-1.0.4",
      date: "Jul 1, 2025",
      changelog: "Nueva versión beta 0.3 con mejoras adicionales y correcciones de errores para Minecraft 1.21.6",
      downloadUrl: "https://modrinth.com/modpack/simonuwu-fabric-project/version/0.3-1.0.4-1.21.6",
      curseforgeUrl: "https://www.curseforge.com/minecraft/modpacks/simonuwu-fabric-project",
      isBeta: true
    },
    {
      id: "80dU7Qsg",
      version: "beta-0.2-1.0.4",
      date: "Jun 24, 2025",
      changelog: "Agregados más mods: 3D Skin Layers, AppleSkin, In-Game Account Switcher, MiniHUD y su API MaliLib, Not Enough Animations",
      downloadUrl: "https://modrinth.com/modpack/simonuwu-fabric-project/version/0.2-1.0.4-1.21.6",
      curseforgeUrl: "https://www.curseforge.com/minecraft/modpacks/simonuwu-fabric-project",
      isBeta: true
    },
    {
      id: "70cU6Qrf",
      version: "beta-0.1-1.0.4",
      date: "Jun 21, 2025",
      changelog: "Primera versión beta para Minecraft 1.21.6 Chase the Skies",
      downloadUrl: "https://modrinth.com/modpack/simonuwu-fabric-project/version/0.1-1.0.4-1.21.6",
      curseforgeUrl: "https://www.curseforge.com/minecraft/modpacks/simonuwu-fabric-project",
      isBeta: true
    }
  ]
};